import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api/v1';
const TOKEN_KEY = import.meta.env.VITE_TOKEN_KEY || 'token';
const AUTH_ROUTES = [
  '/auth/login',
  '/auth/register',
  '/auth/google',
  '/auth/facebook',
  '/auth/forgot-password',
  '/auth/verify-reset-code',
  '/auth/reset-password',
];

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    // Se for um FormData, remover o Content-Type para que o Axios defina automaticamente
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    // Adicionar token de autenticação se disponível
    const token = localStorage.getItem(TOKEN_KEY);
    const requestUrl = config.url || '';
    const isAuthRoute = AUTH_ROUTES.some((route) => requestUrl.includes(route));
    if (token && !isAuthRoute) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (isAuthRoute && config.headers.Authorization) {
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle common errors
api.interceptors.response.use(
  (response) => {
    // Log específico para PIX (mais focado)
    if (response.config?.url?.includes('/credits') && response.data?.pix_qr_code) {
      console.log('🎯 PIX DATA:', {
        pix_qr_code: response.data.pix_qr_code,
        pix_qr_code_url: response.data.pix_qr_code_url,
        expires_at: response.data.expires_at
      });
    }
    
    return response;
  },
  (error) => {
    // Log error mais focado
    console.error('API Error:', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message
    });
    
    // Handle expired token or unauthorized access - MAS APENAS SE NÃO FOR /users/me
    // Isso evita loop de logout durante a verificação inicial de autenticação
    if (error.response && error.response.status === 401 && 
        !error.config?.url?.includes('/users/me') && 
        !error.config?.url?.includes('/auth/')) {
      
      // Only redirect if not on login page and not on public pages
      // (antes havia um `!currentPath.includes('/')`, sempre falso: o redirecionamento nunca acontecia)
      const currentPath = window.location.pathname;
      const publicPaths = ['/', '/login', '/register', '/reset-password', '/terms', '/privacy', '/cookies', '/status'];
      if (!publicPaths.includes(currentPath)) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem('userProfile');
        window.location.href = `/login?expirada=1&next=${encodeURIComponent(currentPath + window.location.search)}`;
      }
    }
    
    return Promise.reject(error);
  }
);

export default api; 